/**
 * Recurso de tradução para permissões
 */

import { createTranslationResource } from '@backstage/core-plugin-api/alpha';
import { permissionsTranslationRef } from './permissions';

export const permissionsTranslations = createTranslationResource({
  ref: permissionsTranslationRef,
  translations: {
    'pt-BR': () => import('./permissions-pt-BR'),
  },
});
